import React, { useState, useMemo } from 'react';
import cn from 'classnames';
import { useTrans } from 'utils/localisation';
import { parseMobileSummary } from '../../utils';
import * as styles from './Summary.module.scss';

export default function Summary({ businessNeed, items }) {
  const t = useTrans(['common', 'pricingCalculator']);
  const [open, setOpen] = useState(false);
  const { summaryContent, summaryCount } = useMemo(
    () => parseMobileSummary(Object.entries(items), businessNeed, t),
    [items, businessNeed, t],
  );

  return (
    <div className={cn(styles.summary, open && styles.open)}>
      <div className={styles.button}>
        <div role="button" className={styles.title} onClick={() => setOpen(!open)}>
          {`${t('summary')} (${summaryCount}):`}
        </div>
        <div className={styles.tags}>
          <div className={styles.text}>{summaryContent}</div>
        </div>
      </div>
    </div>
  );
}
